import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    background = "background",
    image = "image",
    color = "color",
    heading = "heading",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.image]: string;
        [fields.color]: string;
        [fields.heading]: string;
    };
    extendedStyles?: BannerStyles;
}

export interface BannerStyles {
    overlayWrapperStyles?: InjectableCss;
    titleStyles?: InjectableCss;
}

const mapStateToProps = (state: ApplicationState, ownProps: { subCategoryId: string }) => {
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPageState = getCatalogPageStateByPath(state, categoryPath).value;
    return {
        catalogPageState,
        category: getCategoryState(state, ownProps.subCategoryId).value,
        currentLocation: getLocation(state),
    };
};
type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasCategoryContext;

const CustomTitleWrapper = styled.div<{
    backgroundImage: string;
    color: string;
    checkBackground: string;
}>`
    background: ${props => (props.checkBackground === "image" ? `url(${props.backgroundImage})` : props.color)};
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 20px;
    margin-bottom: 40px;
    min-height: 200px;
    width: 100%;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    min-height: 180px;
                `,
                null,
                null,
                null,
            ],
            "max",
        )}
`;

const CustomCategoryName: React.FunctionComponent<Props> = ({
    fields,
    category,
    currentLocation,
    catalogPageState,
}: Props) => {
    const overlayWrapperStyles = {
        // ${backgroundStyles}
        css: css`
            width: calc(100vw - 20px);
            margin-left: calc(-50vw + 50% + 10px);
            margin-top: -15px;
        `,
    };

    const titleStyles = {
        css: css`
            color: ${getColor("common.background")};
            margin: 0;
            text-transform: uppercase;
            text-align: center;
        `,
    };
    if (!category && !catalogPageState) {
        return null;
    }
    const url = currentLocation.pathname + currentLocation.search;

    return (
        <StyledWrapper className="banner-wrapper" {...overlayWrapperStyles}>
            <CustomTitleWrapper backgroundImage={fields.image} color={fields.color} checkBackground={fields.background}>
                {/* <Typography variant="h1" data-test-selector="CustomCategoryName" {...titleStyles}>
                    {url === "/Catalog/components" ? 
                    (fields.heading || fields.overrideTitle) : 
                    category.name}
                </Typography> */}
                <Typography variant="h1" data-test-selector="CustomCategoryName" {...titleStyles}>
                    {catalogPageState?.title
                        ? catalogPageState?.title
                        : fields.heading
                        ? fields.heading
                        : category?.name}
                </Typography>
            </CustomTitleWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CustomCategoryName)),
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
                hideEmptyOption: true,
            },
            {
                fieldType: "Translatable",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "General",
                name: fields.color,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
            },
            {
                fieldType: "Translatable",
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Custom Page Title",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
